import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fileType", "variantContainer"]

  connect() {
    this.updateRequiredIndicators()
  }

  fileTypeChanged() {
    this.updateRequiredIndicators()
  }

  updateRequiredIndicators() {
    const selectedFileTypes = this.getSelectedFileTypes()

    // 모든 variant container를 찾아서 업데이트
    const variantContainers = document.querySelectorAll('[data-weight]')

    variantContainers.forEach(container => {
      // 각 파일 타입별로 필수 표시 업데이트
      const fileTypeBoxes = container.querySelectorAll('[data-file-type]')

      fileTypeBoxes.forEach(box => {
        const fileType = box.getAttribute('data-file-type')
        const requiredIndicator = box.querySelector('.required-indicator')
        const checkIcon = box.querySelector('.text-green-500')

        // 이미 업로드된 파일이 있으면 필수 표시 숨김
        if (checkIcon) {
          if (requiredIndicator) {
            requiredIndicator.style.display = 'none'
          }
        } else {
          // 선택된 file_types에 포함되어 있으면 필수 표시
          if (selectedFileTypes.includes(fileType)) {
            if (requiredIndicator) {
              requiredIndicator.style.display = 'inline'
            } else {
              // 필수 표시가 없으면 추가
              const titleElement = box.querySelector('.variant-title')
              if (titleElement && !checkIcon) {
                const newIndicator = document.createElement('span')
                newIndicator.className = 'required-indicator text-xs text-red-500'
                newIndicator.textContent = '* 필수'
                titleElement.appendChild(newIndicator)
              }
            }
          } else {
            // 선택되지 않은 파일 타입은 필수 표시 숨김
            if (requiredIndicator) {
              requiredIndicator.style.display = 'none'
            }
          }
        }
      })
    })
  }

  getSelectedFileTypes() {
    const checkboxes = this.fileTypeTargets
    return checkboxes
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value)
  }
}